import { useState } from 'react';
import { X } from 'lucide-react';
import { APP_VERSION, CHANGELOG } from '../lib/version';

export function VersionBadge() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-3 right-3 z-50 rounded-full bg-white/80 border border-ink-200 px-2.5 py-0.5 text-meta font-mono tabular-nums text-ink-500 shadow-e1 hover:bg-white hover:text-ink-700 hover:shadow-e2 transition-all"
      >
        v{APP_VERSION}
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-navy-950/45"
          onClick={() => setOpen(false)}
        >
          <div
            className="relative w-full max-w-md mx-4 bg-white rounded-lg shadow-e3 max-h-[80vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-5 py-4 border-b border-ink-100">
              <h2 className="text-base font-semibold text-ink-900">What's new</h2>
              <button
                onClick={() => setOpen(false)}
                className="rounded-md p-1 text-ink-400 hover:text-ink-500 hover:bg-ink-100 transition-colors"
                aria-label="Close"
              >
                <X size={16} />
              </button>
            </div>

            <div className="overflow-y-auto px-5 py-4 space-y-5">
              {CHANGELOG.map((entry) => (
                <div key={entry.version}>
                  <div className="flex items-baseline gap-2 mb-1.5">
                    <span className="text-sm font-semibold font-mono tabular-nums text-ink-900">v{entry.version}</span>
                    <span className="text-xs font-mono tabular-nums text-ink-400">{entry.date}</span>
                    <span className="text-sm text-ink-500">— {entry.title}</span>
                  </div>
                  <ul className="list-disc list-inside space-y-0.5">
                    {entry.changes.map((change, i) => (
                      <li key={i} className="text-sm text-ink-500">
                        {change}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
